import React from "react";
import PropTypes from 'prop-types';
import styles from './taskTitle.css';
import { Badge } from '@momentum-ui/react';
import Timer from '../../timer';
import { getCustomIconText } from "../../../utils/TaskUtils";
import "@momentum-ui/web-components";

const TaskTitle = (props) => {

 const renderTaskType = (mediaType) => {
  switch (mediaType.toLowerCase()) {
    case "telephony":
      return (
        <md-badge color="green" circle small>
          <md-icon name="handset-active_12"></md-icon>
        </md-badge>
      );
    case "outbound telephony":
      return (
        <md-badge color="green" circle small>
          <md-icon name="outgoing-call-active_12"></md-icon>
        </md-badge>
      );
    case "inbound telephony":
      return (
        <md-badge color="green" circle small>
          <md-icon name="incoming-call-active_12"></md-icon>
        </md-badge>
      );
    case "callback":
      return (
        <md-badge color="lime" circle small>
          <md-icon name="icon-icon-callback_18"></md-icon>
        </md-badge>
      );
    case "chat":
      return (
        <md-badge color="blue" circle small>
          <md-icon name="chat-active_12"></md-icon>
        </md-badge>
      );
    case "email":
      return (
        <md-badge color="violet" circle small>
          <md-icon name="email-active_12"></md-icon>
        </md-badge>
      );
    case "sms":
      return (
        <md-badge color="darkmint" circle small>
          <md-icon name="sms_12" color="white"></md-icon>
        </md-badge>
      );
    case "facebook":
      return (
        <md-badge bgColor="#0078FF" circle small>
          <md-icon name="messenger_12" color="white"></md-icon>
        </md-badge>
      );
    case "whatsapp":
      return (
        <md-badge bgColor="#25D366" circle small>
          <md-icon name="whatsApp_12" color="white"></md-icon>
        </md-badge>
      );
    default:
      return (
        <md-badge bgColor="#CCCCCC" textColor="black" circle slot="task-type" small>{getCustomIconText(props.mediaType)}</md-badge>
      );
  }
};

 return (
  <div className={styles.headerTitle}>
   <span className={styles.headerText} id='task-title-header'>{props.name}</span>
   <Badge rounded className={styles.badgeContainer}>
    <div style={{ position: "absolute" }}>{renderTaskType(props.mediaType)}</div>
    <Timer id={`task-title-timer-${props.id}`}
     displayFormat="hh:mm:ss"
     show={true}
     reset={true}
     dynamicFormat={true}
     startTime={props.startTime}
     className={styles.badgeTimer} 
     isInterrupted = {props.isInterrupted}
     />
   </Badge>
  </div>
 );

};

TaskTitle.prototypes = {
 name: PropTypes.string,
 mediaType: PropTypes.string
}

export default TaskTitle;
